import { LeadKanbanCardShimmer } from "./LeadKanbanCardShimmer";

const LeadStagesShimmer = () => {
  return (
    <div className="shrink-0 flex flex-col gap-[8px]">
      <div className="w-[300px] border border-border-gray dark:border-border-gray-dk rounded-[8px] px-[12px] py-[9px] flex justify-between items-center gap-[8px] bg-pure-white dark:bg-pure-white-dk animate-pulse">
        <div className="flex items-center gap-[8px]">
          <div className="w-[62px] h-[18px] bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded animate-pulse"></div>
          <div className="h-[18px] w-[36px] bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded animate-pulse"></div>
        </div>
      </div>

      <div className={`flex flex-col gap-[8px] overflow-y-auto no-scrollbar`}>
        {Array.from({ length: 5 }).map((_, index) => (
          <LeadKanbanCardShimmer key={index} />
        ))}
      </div>
    </div>
  );
};

export default LeadStagesShimmer;
